export default [
  {
    path: "/section-group",
    name: "SectionGroup",
    component: () => import("@/views/Page/SectionGroup/SectionGroup.vue"),
    meta: {
      title: "#Default# | Section Group",
    },
  },
];

